<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
  <img src="./assets/images/loading04.gif" alt="loading" style="width: 270px" />
  <!-- <p style="color: black" class="card-title">กำลังโหลดข้อมูล...</p> -->
</ngx-spinner>
<!-- content -->
<div class="content-wrapper" style="min-height: 307px">
  <div class="col-lg-12">
    <!-- แบบค้นหาข้อมูล -->
    <div class="card no-print">
      <div class="card-header bg-purple">
        <i class="fas fa-clipboard-list"></i>
        รายงานสรุปภาพรวมชาวไร่อ้อยบุรีรัมย์
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>

      <div class="card-body">
        <div class="row justify-content-md-center">
          <div class="col-md-2">
            <mat-form-field appearance="fill">
              <mat-label>เลือกปี</mat-label>
              <mat-select disableRipple required [(ngModel)]="sYear" (ngModelChange)="selectYear()">
                <mat-option *ngFor="let item of listYear" [value]="item">
                  ปีการผลิต - {{ item[2] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-3">
            <div class="position-relative" style="min-width: 320px;">
              <div class="input-group mb-3">
                <span class="input-group-text" id="input-fm">เลือกชาวไร่</span>
                <input type="text" [(ngModel)]="params_like1.search" (input)="LoadDataLike1()" class="form-control"
                  placeholder="Search..." />
                <button *ngIf="params_like1.search.length>0" class="btn btn-outline-secondary"
                  (mousedown)="params_like1.search=''">✕</button>
              </div>
              <div *ngIf="data_list.length>0 && params_like1.search.length>0" class="list-group position-absolute w-100"
                style="z-index: 1000; top: 100%; max-height: 320px; overflow-y: auto; box-shadow: 0 4px 12px rgba(0,0,0,0.2);">
                <button type="button" *ngFor="let item of data_list; let i = index" (click)="selectOption(item,0)"
                  class="list-group-item list-group-item-action">
                  [{{ item.fmcode }}] ชื่อ:{{ item.fmname }}, โซน:{{ item.SUPZONE}}
                </button>
              </div>
            </div>
            <mat-progress-bar *ngIf="loading[0]" mode="indeterminate"></mat-progress-bar>
            <div *ngIf="farmer_id > 0">ชื่อชาวไร่ : {{fmname}} </div>
          </div>
          <div class="col-md-2">
            <button mat-raised-button color="primary" (click)="Finddata()" [disabled]="!submited || isLoading">
              <i class="fa fa-refresh"></i>รีเฟรช
            </button>
            <button mat-raised-button color="accent" (click)="print()" *ngIf="farmerdata.length > 0">
              <i class="fas fa-print"></i> พิมพ์
            </button>
          </div>
        </div>
        <!--<p style="color: red" *ngIf="submited && form.fmcode.errors?.required">
          จำเป็นต้องกรอก รหัสโควตา
        </p>
        <p style="color: red" *ngIf="submited && form.fmcode.errors?.minlength">
          จำเป็นต้องกรอก รหัสโควตา 10 ตัวอักษร
        </p>-->
      </div>
    </div>
    <!-- แบบค้นหาข้อมูล -->
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    <!-- แบบแสดงและปริ้นข้อมูล -->

    <div class="card" *ngIf="farmerdata">
      <div class="card-header">
        <img src="../../../../assets/images/logo-bsf.png" alt="BSF LOGO" />
      </div>
      <!-- ข้อมูลส่วนตัว -->
      <div class="card-body">
        <div class="row justify-content-start">
          <div class="col-2 text-center">
            <div class="image" *ngFor="let item of farmerdata">
              <img src="{{ item.pic_url }}" class="img-circle elevation-3" alt="Farmer BRD Image" style="width: 50%" />
            </div>
          </div>
          <div class="col-8" *ngFor="let item of farmerdata">
            <p class="headText1" style="padding: 1px;">
              {{ item.fmcode_b1 }}&nbsp; | &nbsp;{{item.fmname}}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b>เกรดสินเชื่อ : {{ item.GradeLoan }}</b>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <b>เกรดส่งเสริม : {{ item.gradeFM1 }}.{{ item.gradeFM2 }}.{{ item.gradeFM3 }}</b>
            </p>
            โซน. {{ item.SUPZONE }} ,นสส ({{ item.SUPCODE }}-{{ item.SUPNAME }})
            <p>
              {{ item.address }} <i class="fas fa-mobile-alt"></i>
              {{ item.TEL }} กลุ่ม [ {{ item.GROUPCODE }} ]
            </p>
            <p>
              ปชช.[ {{ item.IDCARD }} ] , ธกส.[ {{ item.BANKTKS }} ] , LHBank [
              {{ item.LHBank }} ] , สถานะLH [ {{ item.RegisterLH }} ]<br />
              , BBL [ {{ item.BANKBBL }} ] , สอน.[ {{ item.CARDFARMER }} ] ,
              สมาคม [ {{ item.AssoID }} ]
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- ข้อมูลส่วนตัว -->

    <!-- ข้อมูลประวัติการทำอ้อย -->
    <div class="card" *ngIf="farmerdata.length">
      <div class="card-header">
        <span class="headText2"><i class="fas fa-history"> </i> ประวัติการทำอ้อย</span>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>

      <div class="card-body">
        <table class="table table-sm">
          <thead>
            <tr class="headText">
              <td style="text-align: center;">ปีการผลิต</td>
              <td class="text-right">พื้นที่ปลูก(ไร่)</td>
              <td class="text-right">ประเมิน(ตัน)</td>
              <td class="text-right">ส่งอ้อย(ตัน)</td>
              <td class="text-right">ซีซีเอส</td>
              <td class="text-right">ผลผลิต(ตัน/ไร่)</td>
              <td class="text-right">หนี้ปัจจุบัน(บาท)</td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let history of getAvailableYears(farmerdata[0])">
              <td style="text-align: center;">{{ history.yearLabel }}</td>
              <td class="text-right">{{ history.area || 0 | number : "1.2-2" }}</td>
              <td class="text-right">{{ history.AS || 0 | number : "1.2-2" }}</td>
              <td class="text-right">{{ history.wgt || 0 | number : "1.2-2" }}</td>
              <td class="text-right">{{ history.ccs || 0 | number : "1.2-2" }}</td>
              <td class="text-right">{{ history.yield || 0 | number : "1.2-2" }}</td>
              <td class="text-right">{{ history.loan || 0 | number : "1.2-2" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- ข้อมูลประวัติการทำอ้อย -->

    <!-- ข้อมูลแปลงอ้อย -->
    <div class="card" *ngIf="plantdata.length > 0">
      <div class="card-header">
        <span class="headText2"><i class="fas fa-clipboard-list"> </i> ข้อมูลแปลงอ้อย
          {{ yearidLb }}</span>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>

      <div class="card-body">
        <table class="table table-sm">
          <thead>
            <tr class="headText text-center">
              <td>ประเภท</td>
              <td class="text-right">จำนวนแปลง</td>
              <td class="text-right">พื้นที่(ไร่)</td>
              <td class="text-right">เป้าหมาย</td>
              <td class="text-right">ประเมิน</td>
              <td class="text-right">ปริมาณตัน</td>
              <td class="text-right">ตันเข้าหีบ</td>
              <td class="text-right">ผลผลิต</td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of plantdata">
              <td>{{ item.CaneType }}</td>
              <td class="text-right">{{ item.cnt }}</td>
              <td class="text-right">
                {{ item.landvalue | number : "1.2-2" }}
              </td>
              <td class="text-right">
                {{ item.target_yield | number : "1.2-2" }}
              </td>
              <td class="text-right">{{ item.yield | number : "1.2-2" }}</td>
              <td class="text-right">{{ item.Assess | number : "1.2-2" }}</td>
              <td class="text-right">
                {{ item.canein || item.Assess_left | number : "1.2-2" }}
              </td>
              <td class="text-right">
                {{ item.yield_end | number : "1.2-2" }}
              </td>
            </tr>
            <tr *ngFor="let item of plantdataS" class="text-bold text-decoration-underline">
              <td>รวม (ปลูกเสร็จเท่านั้น)</td>
              <td class="text-right">{{ item.cnt }}</td>
              <td class="text-right">
                {{ item.landvalue | number : "1.2-2" }}
              </td>
              <td class="text-right">
                {{ item.target_yield | number : "1.2-2" }}
              </td>
              <td class="text-right">{{ item.yield | number : "1.2-2" }}</td>
              <td class="text-right">{{ item.Assess | number : "1.2-2" }}</td>
              <td class="text-right">
                {{ item.canein || item.Assess_left | number : "1.2-2" }}
              </td>
              <td class="text-right">
                {{ item.yield_end | number : "1.2-2" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- ข้อมูลแปลงอ้อย -->

    <!-- รายละเอียดแปลงอ้อย -->
    <div class="card" *ngIf="plantdetail.length > 0">
      <div class="card-header">
        <span class="headText2"><i class="fas fa-tree"> </i> รายละเอียดแปลงอ้อย {{ yearidLb }}
          <span class="badge badge-success">{{ plantdetail.length }}</span>
        </span>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>

      <div class="card-body">
        <table class="table table-sm table-head-fixed">
          <thead class="">
            <tr class="headText text-center">
              <td>เลขแปลง</td>
              <td>ประเภท</td>
              <td>พิ้นที่</td>
              <td>พิ้นที่คงเหลือ</td>
              <td class="text-center">ปลูกเสร็จ</td>
              <td class="text-center">อายุ</td>
              <td>ข้อมูลแปลง</td>
              <td>ใส่ปัจจัย(กก./ไร่)</td>
              <td class="text-right">ตันสูญเสีย</td>
              <td class="text-right">ตัดพันธุ์</td>
              <td class="text-right">ปม.</td>
              <td class="text-right">ตัน ปม.</td>
              <td class="text-right">ตันเข้าหีบ</td>
              <!--<td class="text-right">ปม.ระบบ</td>-->
              <td class="text-right">วงเงินค่าเช่า</td>
              <td class="text-right">วงเงิน</td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let dt of plantdetail; let last = last; let i = index"
              [ngClass]="dt.growed1 === 'P' ? 'bg-warning' : ''">
              <td>{{ dt.intlandno }}</td>
              <td class="text-center">{{ dt.CaneTypeName }}</td>
              <td class="text-right">{{ dt.landvalue | number : "1.2-2" }}</td>
              <td class="text-right">
                {{ dt.landvalue_left | number : "1.2-2" }}
              </td>

              <td class="text-center">
                <i class="fas fa-check-circle text-success" *ngIf="dt.growed1 === 'Y'"></i>
                <i class="fas fa-tractor text-danger" *ngIf="dt.growed1 === 'P'"></i>
              </td>
              <td class="text-center">{{ dt.caneage }}</td>
              <td>
                Z.<b>({{ dt.supzone }})</b> ,R.<b>({{ dt.route }})</b> ,<b>({{ dt.seedname }})</b>
                ,(<label *ngIf="dt.Plottype == 2">เช่า</label><label *ngIf="dt.Plottype == 1">ตนเอง</label>) ,%งอก
                (<b>{{
                  dt.lastGerminationPercent || dt.germination_percentage
                  }}</b>)
                <!--,Y.{{ yearLblast }}(<b>
                  {{ dt.yield_last_year }}</b>)
                ,อ้อยเข้า{{ yearLblast }}(<b>{{ dt.canein_last_year | number:'1.2-2' }}</b>)-->
              </td>
              <td>
                อ.({{ dt.AmountNaturalFertilizer || dt.fertilizer_rate_amt }})
                ด.({{ dt.AmountDolomite || dt.dolomite_rate_amt }}) เคมี1.({{
                dt.AmountFertilizerRound || dt.fertilizer1_per
                }}) เคมี2.({{
                dt.AmountFertilizerRound2 || dt.fertilizer2_per
                }}) เคมี3.({{
                dt.AmountFertilizerRound3 || dt.fertilizer3_per
                }})
              </td>
              <td class="text-right">
                {{ dt.causes_of_crop_loss_amt_3 | number }}
              </td>
              <td class="text-right">
                {{ dt.causes_of_crop_loss_amt_2 | number }}
              </td>
              <td class="text-right">{{ dt.Ton | number }}</td>
              <td class="text-right">{{ dt.Assess | number : "1.2-2" }}</td>
              <td class="text-right">
                {{ dt.Assess_left | number : "1.2-2" }}
              </td>
              <!--<td class="text-right">{{ dt.Ton_b | number:'1.2-2' }}</td>-->
              <td class="text-right">
                {{ dt.rental_limit | number : "1.1-1" }}
              </td>
              <td class="text-right">
                {{ dt.credit_amount | number : "1.1-1" }}
              </td>
            </tr>
            <tr class="text-bolder text-decoration-underline">
              <td>+++รวม {{ plantdetail.length | number }} แปลง</td>
              <td></td>
              <td class="bg-secondary text-right">
                {{ sumland.landvalue1 | number : "1.2-2" }}
              </td>
              <td class="bg-secondary text-right">
                {{ sumland.landvalue2 | number : "1.2-2" }}
              </td>
              <td class="text-center">ไร่</td>
              <td colspan="3"></td>
              <td class="bg-secondary text-right">
                {{ sumland.loss_amt_3 | number }}
              </td>
              <td class="bg-secondary text-right">
                {{ sumland.loss_amt_2 | number }}
              </td>
              <td></td>
              <td class="text-right bg-secondary">
                {{ sumland.Assess | number : "1.2-2" }}
              </td>
              <td class="text-right bg-secondary">
                {{ sumland.Assess_left | number : "1.2-2" }}
              </td>
              <td class="text-right"></td>
              <td class="text-right">
                {{ sumland.sumcredit_amount | number : "1.1-1" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- รายละเอียดแปลงอ้อย -->

    <!-- รายละเอียดแปลงอ้อยยกเลิก -->
    <div class="card" *ngIf="plantdetailX.length > 0">
      <div class="card-header">
        <span class="headText2"><i class="fas fa-tree"> </i> รายละเอียด<b style="color: red">แปลงยกเลิก</b>
          ปี{{ yearidLb }}
          <span class="badge badge-danger">{{ plantdetailX.length }}</span>
        </span>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>

      <div class="card-body">
        <table class="table table-sm table-head-fixed table-danger">
          <thead class="">
            <tr class="headText text-center">
              <td>เลขแปลง</td>
              <td>สถานะแปลง1</td>
              <td>สถานะแปลง2</td>
              <td>ประเภท</td>
              <td>พิ้นที่</td>
              <td>พิ้นที่คงเหลือ</td>
              <!--<td class="text-center">ปลูกเสร็จ</td>-->
              <td class="text-center">อายุ</td>
              <td>ข้อมูลแปลง</td>
              <td>ใส่ปัจจัย(กก./ไร่)</td>
              <td class="text-right">ปม.</td>
              <td class="text-right">ตัน ปม.</td>
              <!--<td class="text-right">ปม.ระบบ</td>-->
              <td class="text-right">วงเงิน</td>
              <td>สาเหตุการยกเลิก</td>
            </tr>
          </thead>
          <tbody>
            <tr style="text-align: center" *ngFor="let dt of plantdetailX; let last = last; let i = index"
              [ngClass]="dt.growed1 === 'P' ? 'bg-warning' : ''">
              <td>{{ dt.intlandno }}</td>
              <td>{{ dt.status1 }}</td>
              <td>{{ dt.status2 }}</td>
              <td>{{ dt.CaneTypeName }}</td>
              <td>{{ dt.landvalue | number : "1.2-2" }}</td>
              <td>
                {{ dt.landvalue_left | number : "1.2-2" }}
              </td>

              <td>{{ dt.caneage }}</td>
              <td>
                Z.<b>({{ dt.supzone }})</b> ,R.<b>({{ dt.route }})</b> ,<b>({{ dt.seedname }})</b>
                ,(<label *ngIf="dt.Plottype == 2">เช่า</label><label *ngIf="dt.Plottype == 1">ตนเอง</label>) ,%งอก
                (<b>{{ dt.lastGerminationPercent }}</b>)
              </td>
              <td>
                อ.({{ dt.AmountNaturalFertilizer }}) ด.({{ dt.AmountDolomite }})
                เคมี1.({{ dt.AmountFertilizerRound }}) เคมี2.({{ dt.AmountFertilizerRound2 }})
                เคมี3.({{ dt.AmountFertilizerRound3 }})
              </td>
              <td class="text-right">{{ dt.Ton | number }}</td>
              <td class="text-right">{{ dt.Assess | number : "1.2-2" }}</td>
              <!--<td class="text-right">{{ dt.Ton_b | number:'1.2-2' }}</td>-->
              <td class="text-left">
                {{ dt.credit_amount | number : "1.1-1" }}
              </td>
              <td>
                {{ dt.cause_of_cancles_n || dt.cause_of_cancle_other }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- รายละเอียดแปลงอ้อย -->

    <!-- รายละเอียดแปลงอ้อยรูท0 -->
    <div class="card" *ngIf="plantdetailX_0.length > 0">
      <div class="card-header">
        <span class="headText2"><i class="fas fa-tree"> </i> รายละเอียด
          <b style=" text-decoration: underline;">แปลงรูท0</b> ปี{{ yearidLb }}
          <span class="badge badge-warning">{{ plantdetailX_0.length }}</span>
        </span>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>

      <div class="card-body">
        <table class="table table-sm table-head-fixed table-warning" *ngIf="plantdetailX_0.length">
          <thead class="">
            <tr class="headText text-center">
              <td>เลขแปลง</td>
              <td>สถานะแปลง1</td>
              <td>สถานะแปลง2</td>
              <td>ประเภท</td>
              <td>พิ้นที่</td>
              <td>พิ้นที่คงเหลือ</td>
              <!--<td class="text-center">ปลูกเสร็จ</td>-->
              <td class="text-center">อายุ</td>
              <td>ข้อมูลแปลง</td>
              <td>ใส่ปัจจัย(กก./ไร่)</td>
              <td class="text-right">ปม.</td>
              <td class="text-right">ตัน ปม.</td>
              <!--<td class="text-right">ปม.ระบบ</td>-->
              <td class="text-right">วงเงิน</td>
            </tr>
          </thead>
          <tbody>
            <tr style="text-align: center" *ngFor="let dt of plantdetailX_0; let last = last; let i = index"
              [ngClass]="dt.growed1 === 'P' ? 'bg-warning' : ''">
              <td>{{ dt.intlandno }}</td>
              <td>{{ dt.status1 }}</td>
              <td>{{ dt.status2 }}</td>
              <td>{{ dt.CaneTypeName }}</td>
              <td>{{ dt.landvalue | number : "1.2-2" }}</td>
              <td>
                {{ dt.landvalue_left | number : "1.2-2" }}
              </td>

              <td>{{ dt.caneage }}</td>
              <td>
                Z.<b>({{ dt.supzone }})</b> ,R.<b>({{ dt.route }})</b> ,<b>({{ dt.seedname }})</b>
                ,(<label *ngIf="dt.Plottype == 2">เช่า</label><label *ngIf="dt.Plottype == 1">ตนเอง</label>) ,%งอก
                (<b>{{ dt.lastGerminationPercent }}</b>)
              </td>
              <td>
                อ.({{ dt.AmountNaturalFertilizer }}) ด.({{ dt.AmountDolomite }})
                เคมี1.({{ dt.AmountFertilizerRound }}) เคมี2.({{ dt.AmountFertilizerRound2 }})
                เคมี3.({{ dt.AmountFertilizerRound3 }})
              </td>
              <td class="text-right">{{ dt.Ton | number }}</td>
              <td class="text-right">{{ dt.Assess | number : "1.2-2" }}</td>
              <!--<td class="text-right">{{ dt.Ton_b | number:'1.2-2' }}</td>-->
              <td class="text-left">
                {{ dt.credit_amount | number : "1.1-1" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- รายละเอียดแปลงอ้อยรูท0 -->

    <!-- หนี้สิน  -->
    <div class="card" *ngIf="loanleftdata">
      <div class="card-header">
        <span class="headText2"><i class="fas fa-calendar-week"> </i> หนี้ปี {{ yearidLb }}
        </span>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <table class="table table-sm table-hover text-nowrap">
          <thead>
            <tr class="">
              <th>#</th>
              <th>จำนวนเงิน</th>
              <th>หมายเหตุ</th>
            </tr>
          </thead>
          <tbody *ngFor="let item of loanleftdata">
            <tr>
              <td>
                <i class="far fa-dot-circle"></i> หนี้ค้าง {{ yearLblast }}
              </td>
              <td>
                <span *ngIf="yearTh === '6465'">{{
                  item.Loanleft6465 | number : "1.1-1"
                  }}</span>
                <span *ngIf="yearTh === '6566'">{{
                  item.Loanleft6566 | number : "1.1-1"
                  }}</span>
                <span *ngIf="yearTh === '6667'">{{
                  item.Loanleft6667 | number : "1.1-1"
                  }}</span>
              </td>
              <td>
                <small>
                  - ระยะสั้น
                  <span *ngIf="yearTh === '6465'" class="Underline">{{
                    item.shortLoan6465 | number : "1.1-1"
                    }}</span>
                  <span *ngIf="yearTh === '6566'" class="Underline">{{
                    item.shortLoan6566 | number : "1.1-1"
                    }}</span>
                  <span *ngIf="yearTh === '6667'" class="Underline">{{
                    item.shortLoan6667 | number : "1.1-1"
                    }}</span>
                  - ระยะยาว
                  <code *ngIf="yearTh === '6465'" class="Underline">{{
                    item.longLoan6465 | number : "1.1-1"
                  }}</code>
                  <code *ngIf="yearTh === '6566'" class="Underline">{{
                    item.longLoan6566 | number : "1.1-1"
                  }}</code>
                  <code *ngIf="yearTh === '6667'" class="Underline">{{
                    item.longLoan6667 | number : "1.1-1"
                  }}</code>
                </small>
              </td>
            </tr>
            <tr>
              <td>
                <i class="far fa-dot-circle"></i>ภาระหนี้ชำระปี {{ yearidLb }}
              </td>
              <td>{{ item.Loanleft6566 | number : "1.1-1" }}</td>
              <td>
                <small>- ปุ๋ย/ยา/อุปกรณ์
                  <code class="Underline">{{
                    item.Loanleft6566 | number : "1.1-1"
                  }}</code>
                  - หนี้ส่งเสริม <code class="Underline"></code> -
                  ระยะยาวชำระ64/65
                  <code class="Underline">{{
                    item.shortLoan6566 | number : "1.1-1"
                  }}</code>
                  - ดอกเบี้ยระยะยาว <code class="Underline"></code> -
                  ดอกเบี้ยระยะยาวปีต่อไป <code class="Underline"></code>
                </small>
              </td>
            </tr>
            <tr>
              <td>
                <dd>- หนี้ระยะสั้น</dd>
              </td>
              <td></td>
              <td>
                <small>- ปุ๋ย/ยา/อุปกรณ์
                  <code class="Underline"></code> -หนี้ส่งเสริม
                  <code class="Underline"></code></small>
              </td>
            </tr>
            <tr>
              <td>
                <dd>- หนี้ระยะยาว</dd>
              </td>
              <td></td>
              <td>
                <small>- โรงงานฯ <code class="Underline"></code> -ธกส.
                  <code class="Underline"></code></small>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- หนี้สิน  -->

    <!-- รายละเอียดหนี้สิน  -->
    <div class="card" *ngIf="LoanDatailData[yearidLb.substring(0, 2)]">
      <div class="card-header">
        <span class="headText2"><i class="fas fa-calendar-week"> </i> รายละเอียดหนี้ปี {{ yearidLb }}
        </span>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <table class="table table-sm">
          <thead>
            <tr class="headText">
              <td>วันที่</td>
              <td>รายการ</td>
              <td class="text-right">จำนวนเงิน</td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of LoanDatailData[yearidLb.substring(0, 2)]">
              <td>{{ item.docdate | adtob }}</td>
              <td>[{{ item.loancode }}] {{ item.loandesc }}</td>
              <td class="text-right">{{ item.doctotal | number : "1.2-2" }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td class="text-right headText2 bg-secondary">
                {{ calculateTotal(LoanDatailData[yearidLb.substring(0, 2)]) | number : "1.2-2" }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <!-- รายละเอียดหนี้สิน  -->

    <div class="card collapsed-card" *ngFor="let keyY of LoanDatailKeys">
      <div class="card-header">
        <span class="headText2"><i class="fas fa-clipboard-list"> </i> หนี้ {{ setnY(keyY) }}
          <span class="badge badge-info">{{ LoanDatailData[keyY].length }}</span>
        </span>
        <!--<span class="text-right">{{ calculateTotal(LoanDatailData[keyY]) | number:'1.2-2' }} </span>-->
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <table class="table table-sm">
          <thead>
            <tr class="headText">
              <td>วันที่</td>
              <td>รายการ</td>
              <td class="text-right">จำนวนเงิน</td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of LoanDatailData[keyY]">
              <td>{{ entry.docdate | adtob }}</td>
              <td>[{{ entry.loancode }}] {{ entry.loandesc }}</td>
              <td class="text-right">{{ entry.balance | number : "1.1-1" }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="2">Total</td>
              <td class="text-right headText2 bg-secondary">
                {{ calculateTotal(LoanDatailData[keyY]) | number : "1.1-1" }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>


    <!-- หนี้ระยะยาว -->
    <div class="card" *ngIf="longdebt.length > 0">
      <div class="card-header">
        <span class="headText2"><i class="fas fa-chart-line"></i> หนี้ระยะยาว
        </span>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="stepper-wrapper">
              <div class="stepper-item" *ngFor="let long of longdebt; let isLast = last"
                [ngClass]="{ 'completed': yearidLb.substring(0, 2) > long.year, 'active': yearidLb.substring(0, 2) == long.year }">
                <div class="step-counter">
                  <i class="fas" [ngClass]="{ 'fa-check-circle text-success': yearidLb.substring(0, 2) > long.year, 
                    'fa-hourglass-half text-warning': yearidLb.substring(0, 2) == long.year, 
                    'fa-circle text-muted': yearidLb.substring(0, 2) < long.year }"></i>
                </div>
                <div class="step-name">
                  <strong>{{ long.year_n }}</strong>
                  <div class="text-muted">
                    {{ long.balance | number : "1.2-2" }} บาท
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- หนี้ระยะยาว -->

    <!-- หนี้ ธกส. -->
    <div class="card" *ngIf="tksdebt">
      <div class="card-header">
        <span class="headText2"><i class="fas fa-clipboard-list"> </i> หนี้ ธกส.
        </span>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="card-body" *ngFor="let item of tksdebt">
        <p>
          <i class="fas fa-truck-moving"></i>โครงการ {{ item.ObjectiveTruck }} |
          {{ item.PayLandSum | number : "1.1-1" }}
        </p>
        <p>
          <i class="far fa-dot-circle"></i> ปี 63/64
          {{ item.PayLandYear1 | number : "1.1-1" }} | ปี 64/65
          {{ item.PayLandYear2 | number : "1.1-1" }} | ปี 65/66
          {{ item.PayLandYear3 | number : "1.1-1" }} | ปี 66/67
          {{ item.PayLandYear4 | number : "1.1-1" }} | ปี 67/68
          {{ item.PayLandYear5 | number : "1.1-1" }} | ปี 68/69
          {{ item.PayLandYear6 | number : "1.1-1" }} | ปี 69/70
          {{ item.PayLandYear7 | number : "1.1-1" }} | ปี 70/71
          {{ item.PayLandYear8 | number : "1.1-1" }}
        </p>
      </div>
    </div>
    <!-- หนี้ ธกส. -->

    <!-- การเบิกปัจจัยการผลิต. -->
    <div class="card" *ngIf="askforproduct">
      <div class="card-header">
        <span class="headText2"><i class="fas fa-clipboard-list"> </i> การเบิกปัจจัยการผลิต
          {{ yearidLb }}</span>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>

      <div class="card-body">
        <table class="table table-sm">
          <thead>
            <tr class="headText">
              <td>วันที่</td>
              <td>รายการ</td>
              <td class="text-right">จำนวน</td>
              <td class="text-right">หน่วยละ</td>
              <td class="text-right">รวมเงิน</td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of askforproduct">
              <!--<td>{{ THtoLocalstring(item.docdate) }}</td>-->
              <td>{{ item.docdate | adtob }}</td>
              <td>{{ item.dscription }}</td>
              <td class="text-right">{{ item.quantity | number : "1.1-1" }}</td>
              <td class="text-right">{{ item.price | number : "1.1-1" }}</td>
              <td class="text-right">
                {{ item.linetotalafvat | number : "1.1-1" }}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="headText2">
              <td colspan="3"></td>
              <td class="text-right">รวมยอดทั้งสิ้น</td>
              <td class="text-right bg-secondary">
                {{ sumgetfactor.sum | number : "1.1-1" }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <!-- การเบิกปัจจัยการผลิต. -->

    <!-- สัญญาค้ำประกัน -->
    <div class="card" *ngIf="contractperson">
      <div class="card-header">
        <span class="headText2"><i class="fas fa-users"> </i> สัญญาค้ำประกัน {{ yearidLb }}</span>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <!-- การค้ำประกัน และ หลักทรัพย์  -->

        <span class="headText my-1">การค้ำประกัน</span>
        <table class="table table-sm">
          <thead>
            <tr class="headText">
              <td class="bg-secondary">บุคคลค้ำประกัน 1</td>
              <td class="bg-secondary">บุคคลค้ำประกัน 2</td>
              <td class="bg-secondary">บุคคลค้ำประกัน 3</td>
              <td class="bg-secondary">บุคคลค้ำประกัน 4</td>
            </tr>
          </thead>
          <tbody *ngFor="let list of contractperson">
            <tr>
              <td>{{ list.FmCode1 }} : {{ list.FullName1 }}</td>
              <td>{{ list.FmCode2 }} : {{ list.FullName2 }}</td>
              <td>{{ list.FmCode3 }} : {{ list.FullName3 }}</td>
              <td>{{ list.FmCode4 }} : {{ list.FullName4 }}</td>
            </tr>
          </tbody>
        </table>

        <span class="headText my-1">หลักทรัพย์</span>
        <table class="table table-sm">
          <thead>
            <tr class="headText">
              <td>ประเภทหลักทรัพย์</td>
              <td>เนื้อที่ (ไร่)/เลขทะเบียน</td>
              <td>ผู้ถือกรรมสิทธิ์</td>
              <td class="text-right">ราคาประเมิน</td>
              <td class="text-center">วันที่ประเมิน</td>
              <td class="text-center">ใช้ได้ถึง</td>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let list of contractperson">
              <tr *ngFor="let item of getCollateralItems(list)">
                <td>{{ item.type }}</td>
                <td>{{ item.qty }}</td>
                <td>{{ item.pronoun }}</td>
                <td class="text-right">{{ item.price | number : "1.1-1" }}</td>
                <td class="text-center">{{ item.dateAS | adtob }}</td>
                <td class="text-center">{{ item.dateEnd | adtob }}</td>
              </tr>
              <tr>
                <td colspan="3"></td>
                <td class="text-right headText2 bg-secondary">
                  {{ list.sumRealty | number : "1.1-1" }}
                </td>
                <td colspan="2"></td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <span class="headText my-1">การค้ำประกันให้บุคคลอื่น</span>
        <!-- ชร.ไปค้ำประกันให้ใครบ้าง -->
        <table class="table table-sm">
          <thead>
            <tr class="headText2">
              <td class="bg-secondary">เลขโควตา</td>
              <td>ชื่อชาวไร่</td>
              <td>คนค้ำ 1</td>
              <td>คนค้ำ 2</td>
              <td>คนค้ำ 3</td>
              <td>คนค้ำ 4</td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let list of contractdata">
              <td>{{ list.FMCODE }}</td>
              <td>{{ list.FullName }}</td>
              <td>{{ list.FmCode1 }} : {{ list.FullName1 }}</td>
              <td>{{ list.FmCode2 }} : {{ list.FullName2 }}</td>
              <td>{{ list.FmCode3 }} : {{ list.FullName3 }}</td>
              <td>{{ list.FmCode4 }} : {{ list.FullName4 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- สัญญาค้ำประกัน -->

    <!-- หนี้ปุ๋ยเทกอง -->
    <div class="card" *ngIf="fertidebt">
      <div class="card-header">
        <span class="headText2"><i class="fas fa-truck-loading"> </i>
          หนี้ปุ๋ยเทกอง{{ yearidLb }}</span>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <p *ngFor="let item of fertidebt" class="headText">
          จำนวนเงิน {{ item.cash_get2 | number : "1.1-1" }} บาท
        </p>
      </div>
    </div>
    <!-- หนี้ปุ๋ยเทกอง -->
    <!-- แบบแสดงและปริ้นข้อมูล -->
  </div>
</div>
<app-footer></app-footer>